import React from "react";
import { Navbar, NavItem } from "../components/Navbar";
import { useLoggedIn } from "../contexts/auth/LoggedInContext";

export function TutorPageLayout({ children }: { children: React.ReactNode }) {

  const { unreadMessages, pendingRequests } = useLoggedIn();

  const navProps: NavItem[]  = [
      { name: "Messages", path: "/messages", notification: unreadMessages },
      { name: "Calendar", path: "/user-calendar", notification: pendingRequests },
      { name: "Account", path: "/account" },
  ];

  return (
    <>
          <Navbar navProps={navProps} showLocation={true} />
      {children}
    </>
  );
}